import { Plan } from '~/graphql/types';

const isPlan = (value: any): value is Plan =>
  Object.values(Plan).includes(value);

export default isPlan;
